export let API_URL:string = ''
export let SIGNALR_URL: string = ''
export let GEMINI_API_KEY: string = ''

const env:string = process.env.NODE_ENV;
switch (env) {
    case 'development':
        API_URL =  'http://localhost:5000/api';
        SIGNALR_URL = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/chatHub';
        GEMINI_API_KEY = 'AIzaSyAAkZtUUpr1CANbqkZJVkqhx-vNbi4aMS8';
      break;
    case 'production':
        API_URL = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/api';
        SIGNALR_URL = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/chatHub';
        GEMINI_API_KEY = 'AIzaSyAAkZtUUpr1CANbqkZJVkqhx-vNbi4aMS8';
      break;
    case 'testing':
        API_URL = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/api';
        SIGNALR_URL = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/chatHub';
        GEMINI_API_KEY = 'AIzaSyAAkZtUUpr1CANbqkZJVkqhx-vNbi4aMS8';
      break;
}